import React from 'react';

import EventDescription from 'buyside/components/presentation/EventPage/EventDescription/eventDescription';
import EventFooter from 'buyside/components/presentation/EventPage/EventFooter/eventFooter';
import EventFormat from 'buyside/components/presentation/EventPage/EventFormat/eventFormat';
import EventHeader from 'buyside/components/presentation/EventPage/EventHeader/eventHeader';
import EventWhyAttend from 'buyside/components/presentation/EventPage/EventWhyAttend/eventWhyAttend';

// import EventAgenda from 'buyside/components/presentation/EventPage/EventAgenda/eventAgenda';
// import EventSpeakers, { Props } from 'buyside/components/presentation/EventPage/EventSpeakers/eventSpeakers';
// import EventSponsors from 'buyside/components/presentation/EventPage/EventSponsors/eventSponsors';

const EventPage: React.FC<{
  contestId?: string;
  isLoggedIn: boolean;
}> = ({ isLoggedIn }) => {
  return (
    <>
      <EventHeader />
      <EventDescription isLoggedIn={isLoggedIn} />
      <EventFormat />
      <EventWhyAttend isLoggedIn={isLoggedIn} />
      <EventFooter />
    </>
  );
};

export default EventPage;
